import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Modal from '@dbk/ui-modal';
import Text, { Large } from '../../../../../../src/components/common/text/index';
import Button from '@dbk/ui-buttons';
import styles from './termsconditions.styles';
import URLResolver from '../../../utils/url-resolver';
import uiJson from '../../../data/ui.json';
 
class TermsConditions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      seenTerms: !this.props.terms.showTermsConditions,
      seenPrivacy: !this.props.terms.showPrivacyAgreement,
      seenSummary: !this.props.terms.showSummaryOfServices,
      checked: false,
      allError: '',
      showModal: true,
    }
 
    this.acceptCondition = this.acceptCondition.bind(this);
    this.handleTerms = this.handleTerms.bind(this);
    this.handlePrivacy = this.handlePrivacy.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.logOut = this.logOut.bind(this);
    this.clickSkipHandler = this.clickSkipHandler.bind(this);
    this.createTitle = this.createTitle.bind(this);
  }
 
  handleTerms() {
    this.setState({ seenTerms: true })
  }
 
  handlePrivacy() {
    this.setState({ seenPrivacy: true })
  }
 
  handleChange() {
    this.setState({ checked: !this.state.checked, 
      seenPrivacy: !this.state.checked,
      seenTerms: !this.state.checked, });
    
  }
 
  acceptCondition() {
    const { terms, i18n: { messages } } = this.props;
    const { seenTerms, seenPrivacy, checked, seenSummary } = this.state;
 
    if (!seenTerms || !seenPrivacy || !checked || !seenSummary) {
      // this.setState({ allError: messages['app.terms.allError'] });
      this.setState({ showModal: false });
      this.props.changePage('/dashboard')
   } else {
      this.setState({ allError: '' });
      this.props.terms.onAccept(
        {
          seenTerms,
          seenPrivacy,
          channel: 'web',
          termsUrl: terms.tcPdfLink ? terms.tcPdfLink : '',
          privacyUrl: terms.paPdfLink,
          tcVersion: terms.tcVersion ? terms.tcVersion : '',
          paVersion: terms.paVersion ? terms.paVersion : '',
          termsChatUrl: terms.tcChatPdfLink ? terms.tcChatPdfLink : '',
          seenChatTerms: terms.showTermsConditionsChat ? terms.showTermsConditionsChat : false,
          tcChatVersion: terms.tcChatVersion ? terms.tcChatVersion : '',
          seenSummary
        });
 
      this.setState({ showModal: false });
    }
  }
 
  logOut() {
    const { auth } = this.props;
    // this.setState({ showModal: false });
    auth.onLogout();
  }
  clickSkipHandler(){
    this.setState({ showModal: false });
    this.props.changePage('/dashboard')
  }
 
  componentWillMount() {
    this.props.languages.getlanguages();
    const { terms } = this.props;
    this.setState({
      termsUrl: terms.tcPdfLink,
      privacyUrl: terms.paPdfLink,
      tcVersion: terms.tcVersion,
      paVersion: terms.paVersion
    });
  }

  createTitle(url, urlName){
    const {i18n: { messages }} = this.props;
    return url ? url.split('/').pop().replace(/_/g, ' '): messages[urlName];
  }
 
  render() {
    const { i18n: { messages }, terms, auth : { langCode }, languages: { destLanguage, destLanguageCode } } = this.props;
    const { termsUrl, privacyUrl } = this.state;
    const remoteUrl = window.location.href.split('ebanking')[0] + '/ebankinguk';
    let termsLink = "";
    let privacyLink ="";
    let termsLinkForGerman = "";
    let privacyLinkForGerman ="";
    const termsTitle = this.createTitle(termsUrl,'app.terms.termsPdf');
    const privacyTitle = this.createTitle(privacyUrl,'app.terms.privacyPdf');

    termsLinkForGerman = remoteUrl + termsUrl;
    privacyLinkForGerman = remoteUrl + privacyUrl;
    termsLink = remoteUrl + termsUrl;
    privacyLink = remoteUrl + privacyUrl;
    
 
    const headline = (terms.newUserTc || terms.newUserPa) ?
      messages['app.terms.headline'] : messages['app.terms.amendedHeadline'];
 
    return (
      <Modal
        isActive={this.state.showModal}
        onClose={this.clickSkipHandler}
        header={headline}
        content={
          <div className="scene">
            <div className="row">
              {(termsUrl != null || privacyUrl != null) ?
                <div className="columns small-12 small-centered medium-9 medium-centered large-8 large-centered">
                  <div className="pad-bottom-20">
                    <Text> {messages['app.terms.readText']} </Text>
                  </div>
                  <div className=" pad-bottom-20">
                    <Text>{messages['app.terms.downloadPdf']} </Text>
                  </div>
                  <div className="pad-bottom-20">
                    <ol className="tnc-list">
                      {termsUrl && <li><a href={destLanguageCode == 'en-GB' ? termsLink : termsLinkForGerman} download={termsTitle} target="_blank" onClick={() => this.handleTerms()}><Text style={styles.termsColor}> {messages['app.terms.termsPdf']}</Text></a></li>}
                      
                      {privacyUrl && <li><a href={destLanguageCode == 'en-GB' ? privacyLink : privacyLinkForGerman} download={privacyTitle} target="_blank" onClick={() => this.handlePrivacy()}><Text style={styles.termsColor}> {messages['app.terms.privacyPdf']}</Text></a></li>}
                    </ol>
                  </div>
                  <div className="termsCondition-main-wrapper">
                    <div className="center-content pad-top-10">
                      <div id="chkbx_accept_termsConditions_test">
                        <input type='checkbox' checked={this.state.checked} onChange={(e) => this.handleChange(e)} />
                      </div>
                      <View style={styles.checkRead} id="txt_termAgreement_termsConditions_test">
                        <Text>{messages['app.terms.agreement']}</Text>
                      </View>
                    </div>
                  </div>
                  <div className="text-center pad-top-20">
                    <Text style={styles.errorColor}>{this.state.allError}</Text>
                  </div>
                  <div className="small-6 small-centered pad-top-10 margin-bottom-20">
                    <Button testID="btn_acceptContinue_termsCondition_test" fullWidth size='normal' onPress={this.acceptCondition}>
                      {messages['app.terms.acceptContinue']}
                    </Button>
                  </div>
                </div>
                :
                <div className="columns small-12 small-centered medium-9 medium-centered large-8 large-centered">
                  <div className="text-center">
                    <Large>{messages['app.terms.linkError']}</Large>
                  </div>
                  <div className="small-6 small-centered pad-top-50">
                    <Button fullWidth size='normal' onPress={this.logOut}>
                      {messages['app.terms.logout']}
                    </Button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      />
    );
  }
}
 
export default createContainer({
  $queries: {
    terms: {
      tcPdfLink: true,
      paPdfLink: true,
      tcVersion: true,
      paVersion: true,
      showTermsConditions: true,
      showPrivacyAgreement: true,
      newUserTc: true,
      newUserPa: true,
      termsChatUrl: true,
      seenChatTerms: true,
      tcChatVersion: true,
      onAccept: { $call: 'saveTermsPrivacy' },
      showSummaryOfServices: true,
    },
    languages: {
      getlanguages: { $call: 'getlanguages' },
      destLanguage: true,
      destLanguageCode: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true,
      onLogout: { $call: 'logout' },
      langCode : true,
    },
    changePage: { $call: 'ui.history.push' },
  },
})(TermsConditions);